export class PhaseConstants {
  public static readonly EnrollmentId = 1;
}
